export default __webpack_public_path__ + "static/media/landingimage4.2008b0de.png";